module.exports = __webpack_public_path__ + "static/office_transfer-a39e7574a70a98b084c6b8b2472ec9f4.jpeg";